import React, { useState } from 'react';
import { FlatList } from "react-native"
import type { PollCampaignProps, PollProps, PollResponseProps } from "../../types"
import { Icons } from '../../Components';
import PollSelectCard from './PollSelectCard';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type PollQuestionsSectionProps = {
    poll_campaign:PollCampaignProps,
    polls:PollProps[],
    poll_responses:PollResponseProps[],
    onSelectPoll:(p:PollProps) => void
}

const PollQuestionsSection = ({ poll_campaign, polls, poll_responses, onSelectPoll }:PollQuestionsSectionProps) => {
    const Colors = useColors();
    const [ section_data, setSectionData ] = useState<{
        loading:boolean,
        expanded:boolean,
    }>({
        loading: false,
        expanded: true
    });
    const { expanded } = section_data;


    const renderPolls = (data:{item:PollProps, index:number}) => {
        const my_response = poll_responses.find(r => r.poll_id == data.item.poll_id)
        const response_option = data.item.poll_options?.find(po => po.poll_option_id == my_response?.poll_option_id);
        return (
            <View transparent style={{ borderBottomWidth:1, borderBottomColor:Colors.borders.light }}>
                <PollSelectCard
                    poll={data.item}
                    disabled={false}
                    selected={false}
                    poll_campaign={poll_campaign}
                    poll_response={my_response}
                    show_response={my_response ? true : false}
                    response_option={response_option}
                    onSelect={(p) => onSelectPoll(p)}
                />
            </View>
        )
    }

    return (
        <View float>
            <Button style={{ flexDirection:'row', alignItems:'center', padding:20, backgroundColor:Colors.views.header }} onPress={() => setSectionData({ ...section_data, expanded: !expanded })}>
                <Icons.QuestionIcon size={18} color={Colors.text.h1} />
                <View transparent style={{flex:1, marginLeft:10}}>
                    <Text theme='h1'>Questions</Text>
                    <Text style={{ marginTop:3 }} theme='description'>Available questions can be found below</Text>
                </View>
                <Icons.ChevronIcon direction={expanded?'up':'down'} color={Colors.text.h1} size={8} />
            </Button>
            {expanded ?
            <View transparent type='body' style={{ padding:10 }}>
                <FlatList
                    data={polls.sort((a,b) => a.priority - b.priority)}
                    renderItem={renderPolls}
                    keyExtractor={(item) => item.poll_id.toString()}
                />
            </View>
            :<></>}
        </View>
    )
}

export default PollQuestionsSection